module.exports = __webpack_public_path__ + "static/media/logo-big.c38c58b7.svg";